var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"loadingButton-button loadingButton-loading"},[(_vm.iconClass)?_c('span',{staticClass:"button-contents"},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_vm._e()]):_c('span',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }